export const STAGE_LABELS = {
    IDEA: 'Idea',
    POC: 'Proof of Concept',
    MVP: 'MVP',
    ADVANCED: 'Advanced',
};
export const RAISE_STAGE_LABELS = {
    PRE_SEED: 'Pre-Seed',
    SEED: 'Seed',
    SERIES_A: 'Series A',
    SERIES_B: 'Series B',
};
export function stageLabel(value) {
    if (!value)
        return '';
    return STAGE_LABELS[value] ?? value;
}
export function raiseStageLabel(value) {
    if (!value)
        return '';
    return RAISE_STAGE_LABELS[value] ?? value;
}
//# sourceMappingURL=stages.js.map